import { useEffect } from 'react';
import PageLayout from '../../components/base/PageLayout';

export default function Legal() {
  useEffect(() => {
    document.title = '特定商取引法に基づく表記 - 法的事項・利用規約｜執事ベル';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '執事ベルが提供するサービスに関する特定商取引法に基づく表記。販売事業者名、所在地、連絡先、サービス料金、支払い方法、キャンセルポリシー、返金規定など、法令に基づき必要事項を記載。企業研修、マナー講座、プライベート執事サービス、コンサルティングなど、各サービスのご利用前に必ずご確認ください。');
    }

    // Add Keywords meta tag
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', '特定商取引法, 法的事項, 利用規約, 返金規定, キャンセルポリシー');
    } else {
      const keywordsTag = document.createElement('meta');
      keywordsTag.name = 'keywords';
      keywordsTag.content = '特定商取引法, 法的事項, 利用規約, 返金規定, キャンセルポリシー';
      document.head.appendChild(keywordsTag);
    }

    // Add Canonical URL
    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', `${import.meta.env.VITE_SITE_URL || "https://butlerbell.jp"}/legal`);
    } else {
      const canonical = document.createElement('link');
      canonical.rel = 'canonical';
      canonical.href = `${import.meta.env.VITE_SITE_URL || "https://butlerbell.jp"}/legal`;
      document.head.appendChild(canonical);
    }

    // Add Last-modified
    const lastModified = document.querySelector('meta[name="last-modified"]');
    if (lastModified) {
      lastModified.setAttribute('content', new Date().toISOString().split('T')[0]);
    } else {
      const lastModTag = document.createElement('meta');
      lastModTag.name = 'last-modified';
      lastModTag.content = new Date().toISOString().split('T')[0];
      document.head.appendChild(lastModTag);
    }

  }, []);

  return (
    <PageLayout hero={<>
<section className="py-32 bg-gradient-to-br from-[#1a1a1a] via-[#2a2a2a] to-[#1a1a1a]">
        <div className="max-w-7xl mx-auto px-8 text-center">
          <h1 
            className="text-3xl md:text-5xl font-light text-white mb-8 tracking-wide"
            style={{ fontFamily: '"Noto Serif JP", serif' }}
          >
            特定商取引法に基づく表記
          </h1>
          <p 
            className="text-xl md:text-2xl text-amber-400 font-light tracking-wider"
            style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
          >
            法的事項について
          </p>
        </div>
      </section>
</>}>
      {/* Hero Section */}
      

      {/* Content Section */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-8">
          <div className="space-y-12">
            <div className="bg-[#f5f5f5] p-8 rounded-lg">
              <h2 
                className="text-3xl font-medium text-[#1a1a1a] mb-8"
                style={{ fontFamily: '"Noto Serif JP", serif' }}
              >
                事業者情報
              </h2>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div>
                  <h3 
                    className="text-lg font-medium text-[#917c50] mb-3"
                    style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
                  >
                    事業者名
                  </h3>
                  <p 
                    className="text-gray-700"
                    style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
                  >
                    執事ベル
                  </p>
                </div>
                
                <div>
                  <h3 
                    className="text-lg font-medium text-[#917c50] mb-3"
                    style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
                  >
                    代表者
                  </h3>
                  <p 
                    className="text-gray-700"
                    style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
                  >
                    執事ベル（全日本執事協会 頭取）
                  </p>
                </div>
                
                <div>
                  <h3 
                    className="text-lg font-medium text-[#917c50] mb-3"
                    style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
                  >
                    所在地
                  </h3>
                  <p 
                    className="text-gray-700"
                    style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
                  >
                    〒135-0064<br />
                    東京都江東区青海2丁目7−4
                  </p>
                </div>
                
                <div>
                  <h3 
                    className="text-lg font-medium text-[#917c50] mb-3"
                    style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
                  >
                    連絡先
                  </h3>
                  <p 
                    className="text-gray-700"
                    style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
                  >
                    メール：info@butlerbell.jp<br />
                    ※お電話でのお問い合わせは、お問い合わせフォームよりご連絡ください
                  </p>
                </div>
              </div>
            </div>

            <div>
              <h2 
                className="text-3xl font-medium text-[#1a1a1a] mb-6"
                style={{ fontFamily: '"Noto Serif JP", serif' }}
              >
                販売価格
              </h2>
              <div 
                className="text-gray-700 leading-relaxed space-y-4"
                style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
              >
                <p>各サービスの価格は、サービス詳細ページまたはお見積もり時にご提示いたします。価格はすべて税込み表示となっております。</p>
              </div>
            </div>

            <div>
              <h2 
                className="text-3xl font-medium text-[#1a1a1a] mb-6"
                style={{ fontFamily: '"Noto Serif JP", serif' }}
              >
                支払方法
              </h2>
              <div 
                className="text-gray-700 leading-relaxed space-y-4"
                style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
              >
                <p>以下の支払方法をご利用いただけます：</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>銀行振込（前払い）</li>
                  <li>クレジットカード決済</li>
                  <li>請求書払い（法人のみ、事前審査あり）</li>
                </ul>
              </div>
            </div>

            <div>
              <h2 
                className="text-3xl font-medium text-[#1a1a1a] mb-6"
                style={{ fontFamily: '"Noto Serif JP", serif' }}
              >
                支払時期
              </h2>
              <div 
                className="text-gray-700 leading-relaxed space-y-4"
                style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
              >
                <ul className="list-disc list-inside space-y-2">
                  <li>銀行振込：サービス実施前までにお振込みください</li>
                  <li>クレジットカード決済：お申し込み時に決済いたします</li>
                  <li>請求書払い：請求書発行後30日以内にお支払いください</li>
                </ul>
              </div>
            </div>

            <div>
              <h2 
                className="text-3xl font-medium text-[#1a1a1a] mb-6"
                style={{ fontFamily: '"Noto Serif JP", serif' }}
              >
                サービス提供時期
              </h2>
              <div 
                className="text-gray-700 leading-relaxed space-y-4"
                style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
              >
                <p>お申し込み確認後、お客様とのスケジュール調整を行い、合意した日程でサービスを提供いたします。具体的な提供時期は、サービス内容により異なりますので、お申し込み時にご相談ください。</p>
              </div>
            </div>

            <div>
              <h2 
                className="text-3xl font-medium text-[#1a1a1a] mb-6"
                style={{ fontFamily: '"Noto Serif JP", serif' }}
              >
                キャンセル・返金について
              </h2>
              <div 
                className="text-gray-700 leading-relaxed space-y-4"
                style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
              >
                <p>キャンセルポリシーは以下の通りです：</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>サービス実施日の14日前まで：無料キャンセル</li>
                  <li>サービス実施日の7日前まで：料金の50%</li>
                  <li>サービス実施日の3日前まで：料金の80%</li>
                  <li>サービス実施日の前日・当日：料金の100%</li>
                </ul>
                <p className="mt-4">※天災その他やむを得ない事情による場合は、個別にご相談させていただきます。</p>
              </div>
            </div>

            <div>
              <h2 
                className="text-3xl font-medium text-[#1a1a1a] mb-6"
                style={{ fontFamily: '"Noto Serif JP", serif' }}
              >
                その他の費用
              </h2>
              <div 
                className="text-gray-700 leading-relaxed space-y-4"
                style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
              >
                <p>サービス料金以外に以下の費用が発生する場合があります：</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>交通費（実費）</li>
                  <li>宿泊費（遠方での研修の場合）</li>
                  <li>教材費（特別な教材が必要な場合）</li>
                </ul>
                <p className="mt-4">※事前にお見積もりでご提示いたします。</p>
              </div>
            </div>

            <div>
              <h2 
                className="text-3xl font-medium text-[#1a1a1a] mb-6"
                style={{ fontFamily: '"Noto Serif JP", serif' }}
              >
                免責事項
              </h2>
              <div 
                className="text-gray-700 leading-relaxed space-y-4"
                style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
              >
                <p>当サービスは、提供するサービスの内容について細心の注意を払っておりますが、その完全性、正確性、有用性について保証するものではありません。また、サービス利用により生じた損害について、当方の故意または重大な過失による場合を除き、一切の責任を負いかねます。</p>
              </div>
            </div>

            <div className="mt-16 text-center">
              <p 
                className="text-sm text-gray-500"
                style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
              >
                制定日：2024年12月19日<br />
                最終更新日：2024年12月19日
              </p>
            </div>
          </div>
        </div>
      </section>
    </PageLayout>
  );
}
